import React from 'react';
import PropTypes from 'prop-types';

import CashPrice from '@components/application/pricing/cashPrice';
import Saving from '@components/application/pricing/saving';
import MonthlyPayment from '@components/application/pricing/monthlyPayment';
import Deposit from '@components/application/pricing/deposit';
import CostNew from '@components/application/pricing/costNew';
import ListPrice from '@components/application/pricing/listPrice';
import PreSalePrice from '@components/application/pricing/preSalePrice';

const ProductPricing = ({
  businessContractHire,
  businessVehicle,
  cashPrice,
  cashPricePrefix,
  cashPriceSuffix,
  costNewPrice,
  deposit,
  extras,
  isBusinessContractHire,
  listPrice,
  monthlyPayment,
  preSalePrice,
  saving,
  savingPrefix,
  savingSuffix,
  showTooltip,
  stockReference,
}) => {
  const hideCashPrice = () =>
    cashPrice === 0 && (businessVehicle || isBusinessContractHire);

  const renderFinance = () => {
    if (!monthlyPayment) return null;

    return (
      <div className="ch-clearfix ac-pricing__finance">
        <div className="ac-pricing__deposit-wrapper">
          <Deposit
            amount={deposit}
            isBusinessContractHire={isBusinessContractHire}
          />
        </div>
        <div className="ac-pricing__monthly-wrapper">
          <MonthlyPayment
            amount={monthlyPayment}
            showTooltip={showTooltip}
            stockReference={stockReference}
          />
          {businessVehicle && businessContractHire && (
            <span className="ac-pricing__extras">{extras}</span>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="ac-pricing">
      <div className="ac-pricing__additional-pricing">
        {costNewPrice && <CostNew amount={costNewPrice} />}
        {listPrice && <ListPrice amount={listPrice} />}
        {preSalePrice && <PreSalePrice amount={preSalePrice} />}
      </div>

      {!hideCashPrice() && (
        <CashPrice
          amount={cashPrice}
          prefix={cashPricePrefix}
          suffix={cashPriceSuffix}
        />
      )}
      {saving && (
        <Saving amount={saving} prefix={savingPrefix} suffix={savingSuffix} />
      )}
      {!hideCashPrice() && extras && (
        <span className="ac-pricing__extras">{extras}</span>
      )}
      {renderFinance()}
    </div>
  );
};

ProductPricing.propTypes = {
  businessContractHire: PropTypes.bool,
  businessVehicle: PropTypes.bool,
  cashPrice: PropTypes.number,
  cashPricePrefix: PropTypes.string,
  cashPriceSuffix: PropTypes.string,
  costNewPrice: PropTypes.number,
  deposit: PropTypes.number,
  extras: PropTypes.string,
  isBusinessContractHire: PropTypes.bool,
  listPrice: PropTypes.number,
  monthlyPayment: PropTypes.number,
  preSalePrice: PropTypes.number,
  saving: PropTypes.number,
  savingPrefix: PropTypes.string,
  savingSuffix: PropTypes.string,
  showTooltip: PropTypes.bool,
  stockReference: PropTypes.string,
};

export default ProductPricing;
